/**
 * Route definitions for the Analytics module.
 * Lazily loads the main analytics page with embedded Power BI reports.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const AnalyticsRoutes = createFeatureRoutes(
  'analytics',
  {
    main: () => import('../presentation/pages/AnalyticsPage')
  },
  [{ path: '', pageKey: 'main' }]
);

export default AnalyticsRoutes;
